import { ConsumptionDataExchangeType } from '@/types/iot-portal';

export const consumptionTypeName = (type: string | undefined): string => {
  if (type) {
    switch (type) {
      case ConsumptionDataExchangeType.VarysSW:
        return 'Stadtwerke Eisleben';
      case ConsumptionDataExchangeType.VarysMDL:
        return 'Varys MDL';
      case ConsumptionDataExchangeType.EAD_Buchholz:
        return 'EAD Buchholz';
      case ConsumptionDataExchangeType.QSam:
        return 'Smarvis';
      case ConsumptionDataExchangeType.Kugu:
        return 'Kugu';
      case ConsumptionDataExchangeType.EAD_Zeulenroda:
        return 'EAD Zeulenroda';
      case ConsumptionDataExchangeType.EAD_BergischesLand:
        return 'EAD BergischesLand';
      default:
        return type;
    }
  } else {
    return '';
  }
};
